import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// Purchasing-power pricing regions: a discount percentage applied to the
// default-currency (USD) price for buyers in the region's countries.
export const pricingRegionsList = (params = '') => Http.get(`/pricing-regions${serialize(params)}`)
export const pricingRegionByID = (params = '') => Http.get(`/pricing-regions/${params}`)
export const pricingRegionCreate = (params = '') => Http.post('/pricing-regions', params)
export const pricingRegionUpdate = (params = '') => Http.put(`/pricing-regions/${params.id}`, params)
export const pricingRegionDestroy = (params = '') => Http.delete(`/pricing-regions/${params.id}`)
